export default __webpack_public_path__ + "static/media/BrutalType-Bold.78e47c39.eot";